import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { VerdictBadge, TierBadge, RiskDot } from "@/components/Badges";
import { ListChecks } from "lucide-react";

export default function ReviewQueue() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api.get("/review-queue").then((r) => setRows(r.data)).catch(() => {});
  }, []);

  return (
    <div className="space-y-6" data-testid="review-queue-page">
      <div>
        <h1 className="font-heading text-2xl font-bold tracking-tight text-slate-100 sm:text-3xl">
          Review Queue
        </h1>
        <p className="mt-1 text-sm text-slate-400">
          Cases routed to human review — sorted by risk score. Reviewers make the final call.
        </p>
      </div>

      {rows.length === 0 ? (
        <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-slate-800 py-20 text-center">
          <ListChecks className="mb-3 h-10 w-10 text-slate-700" />
          <p className="text-slate-400">The review queue is empty.</p>
        </div>
      ) : (
        <div className="space-y-2" data-testid="review-queue-list">
          {rows.map((s) => (
            <Link
              key={s.id}
              to={`/cases/${s.id}`}
              data-testid={`queue-item-${s.id}`}
              className="flex items-center justify-between gap-4 rounded-xl border border-slate-800 bg-slate-900/60 px-5 py-4 transition-colors hover:border-amber-700/60"
            >
              <div className="min-w-0">
                <div className="truncate font-medium text-slate-100">{s.entity.name}</div>
                <div className="font-mono text-[10px] uppercase tracking-wide text-slate-500">
                  {s.entity.entity_type} · {s.entity.jurisdiction || "—"} · {s.created_at?.slice(0, 10)}
                </div>
                {s.result?.hard_overrides?.[0] && (
                  <div className="mt-1 truncate text-xs text-amber-400">⚠ {s.result.hard_overrides[0]}</div>
                )}
              </div>
              <div className="flex shrink-0 items-center gap-3">
                <RiskDot color={s.risk_color} score={s.risk_score} />
                <span className="font-heading text-2xl font-extrabold tabular-nums text-amber-300">
                  {s.risk_score}
                </span>
                <div className="flex flex-col items-end gap-1.5">
                  <VerdictBadge verdict={s.verdict} />
                  <TierBadge tier={s.assigned_tier} />
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
